var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBurgerMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 64 64",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "6DDA231F-39C0-4E54-AF21-21001F604C6A@2x")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M47,42 L47,45 L10,45 L10,42 L47,42 Z M39,30 L39,33 L10,33 L10,30 L39,30 Z M54,18 L54,21 L10,21 L10,18 L54,18 Z",
  id: "Combined-Shape"
})));
export { SvgBurgerMenu as ReactComponent };